import _ from 'lodash';

import { getSelectedOrganizationId } from '../../../selectors/organizations/organizations';
import { applicationsService } from '../../../transport';
import { Project } from '../../../types/entities';

import { getProjectsData } from './projects';
import {
  buildLoadDataCachedFn,
  fetchDataOnAllApplicationsChange,
} from './utils/utils';

export const NAMES = {
  ALL_APPLICATIONS_GET_SUCCESS: 'ALL_APPLICATIONS_GET_SUCCESS',
};

const allApplicationsGetSuccess = (allApplications) => ({
  type: NAMES.ALL_APPLICATIONS_GET_SUCCESS,
  payload: allApplications,
});

const loadData = (context, dispatch, getState) => {
  const state = getState();
  const organizationId = getSelectedOrganizationId(state, { router: context });

  if (!organizationId) {
    return Promise.reject({
      code: 404,
    });
  }

  return dispatch(getProjectsData(context))
    .then((projects: Project[]) => {
      return Promise.all(
        _.map(projects, (project: Project) => {
          return applicationsService
            .getApplications({ organizationId, projectId: project.id })
            .then(({ data }) => ({
              applications: data.payload,
              project,
            }));
        }),
      );
    })
    .then((projectsWithApplications) => {
      return _.flatMap(
        projectsWithApplications,
        ({ applications, project }) => {
          return _.map(applications, (app) => ({
            ...app,
            project,
          }));
        },
      );
    })
    .then((applicationsWithProjects) =>
      dispatch(allApplicationsGetSuccess(applicationsWithProjects)),
    );
};

const loadDataCached = buildLoadDataCachedFn(
  loadData,
  fetchDataOnAllApplicationsChange,
);

export const getAllApplicationsData = (context) => (dispatch, getState) => {
  return loadDataCached(context, dispatch, getState);
};
